import { css } from "@emotion/css";

import { Loader } from "@/modules/theme/components/Loader/Loader";
import { yellow } from "@/modules/theme/utils/colors";

export const FirstLoadingLevelsView = () => {
  const classes = createFirstLoadingLevelsStyles();

  return (
    <div className={classes.loaderWrapper}>
      <Loader size={80} variant="primary" />
    </div>
  );
};

function createFirstLoadingLevelsStyles() {
  return {
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      height: 400,
    }),
  };
}
